// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.profile-post-video-clip-modal__container{
    display: flex;
    align-items: flex-start;
}

.profile-post-video-clip-modal__container .profile-post-video-clip__data__positions-graph{
    width: 55%;
    background: var(--black-color);
}

.profile-post-video-clip__data__positions-graph .post-profile_video_clip_post{
    aspect-ratio: unset;
    text-align: center;
    background: var(--black-color);
    display: flex;
    align-items: center;
    justify-content: center;
}

.profile-post-video-clip__data__positions-graph .post-profile_video_clip_post.lock {
    opacity: 70%;
    cursor: not-allowed;
}

.profile-post-video-clip__data__positions-graph .post-profile_video_clip_post .hubicon-lock_fill {
    font-size: 24px;
    position: absolute;
}

.profile-post-video-clip__data__positions-graph .post-profile_video_clip_post .hubicon-lock_fill::before {
    color: var(--white-color);
}

.profile-post-video-clip__data__positions-graph .post-profile_video_clip_post .post-profile__video_clip{
    max-width: 600px;
    max-height: 700px;
}

.profile-post-video-clip__data__positions-graph .post-profile_video_clip_post .post-profile_video_clip_video-control{
    height: 90%;
}

.profile-post-video-clip-media-modal_comments{
    width: 45%;
}

.profile-post-video-clip-media-modal_comments .post_video_clips_actions__action{
    margin-right: unset;
}

.profile_post_new-comment__photo{
    margin-right: var(--space-half);
    padding: var(--space-quarter);
}

.profile_post_new-comment__photo img{
    width: var(--space-x2-and-half);
    height: var(--space-x2-and-half);
    border-radius: 50%;
}


.profile-post-video-clip-modal__tournament-match-info{
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.profile-post-video-clip-modal__tournament_info{
    display: flex;
    align-items: center;
    background: var(--new-background-color);
    padding: 2px 4px;
    border-radius: 2px;
}

.profile-post-video-clip-modal__tournament_info .baloa-table{
    color: var(--primary-very-dark-color);
}

.profile-post-video-clip-modal__tournament_info__img{
    margin-right: 4px;
}

.profile-post-video-clip-modal__tournament_info__img img {
    width: 16px;
    height: 16px;
    border-radius: 50%;        
}

.profile-post-video-clip-modal__tournament_info__img .icon-ball {
    color: var(--white-color );
    font-size: 12px;
    border-radius: 50%;
    padding: 2px;    
}

.profile-post-video-clip-modal__match_date.baloa-table{
    color: var(--primary-very-dark-color);
    background: var(--new-background-color);
    padding: 2px 4px;
    border-radius: 2px;
}

.profile-post-video-clip-modal__tournament-match-data{
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 14px;
}

.profile-post-video-clip-modal__tournament-match-data img{
    width: 24px;
    height: 24px;
    border-radius: 50%;
    margin: 0 8px;
}

.profile-post-video-clip-modal__tournament-match-data .icon-ball{
    color: var(--white-color );
    font-size: 20px;
    border-radius: 50%;
    padding: 2px;
    margin: 0 8px;
}

.profile-post-video-clip-modal__tournament-match-data__score{
    display: flex;
    align-items: center;
    width: 20%;
    justify-content: center;
}

.profile-post-video-clip-modal__tournament-match-data__label.baloa-table{
    color: var(--primary-very-dark-color);
    font-weight: var(--font-medium);
}

.profile-post-video-clip-modal__tournament-match-data__score__left {
    text-align: end;
}

.profile-post-video-clip-modal__tournament-match-data__score__right {
    text-align: start;
}

.profile-post-video-clip-modal__tournament-match-data__score__center{
    margin: 0 4px;
}

.profile-post-video-clip-modal__table-body__container{
    box-shadow: 0px 1px 4px rgba(150, 150, 150, 0.25);
    border-radius: 8px; 
    padding: 12px 8px;
    margin: 24px;
}

.profile-post-video-clip-modal__info-message__container {
    background: var(--white-color);
    border-radius: 8px;
    padding: 12px;
    margin: 12px;
}

.profile-post-video-clip-modal__info-message {
    display: flex;
    align-items: center;
    border-radius: 4px;
    background: var(--new-informative-banner-bg-color);
    padding: 12px;
}

.profile-post-video-clip-modal__info-message .hubicon-info::before {
    color: var(--new-informative-banner-color);
    margin-right: 8px;
}

.profile-post-video-clip-modal__info-message__text .baloa-normal-medium {
    display: flex;
    align-items: center;
}

.profile-post-video-clip-modal__info-message__text .baloa-names{
    font-weight: var(--font-regular);
    margin-top: 8px;
}


.profile-post-video-clip-modal__info-message__text .hubicon-award_star {
    font-size: 20px;
    margin-right: 4px;
}
/* @media screen and (max-width: 1600px){
    .profile-post-video-clip-modal .modal2__container{
        width: 90%;
    }
}

@media screen and (max-width: 1100px){
    .profile-post-video-clip-modal .modal2__container{
        width: 90%;
    }
} */


@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */
    .profile-post-video-clip-modal .modal2__container{
        width: 100%;
        height: 100%;
        margin: 0;
        border-radius: 0;
        box-shadow: 0px 1px 4px rgba(150, 150, 150, 0.25);
        max-height: 100%;
    }

    .profile-post-video-clip-modal .modal2__content{
        height: 100vh;
    }

    .profile-post-video-clip-modal__container{
        display: flex;
        flex-direction: column;
        height: 100%;
    }

    .profile-post-video-clip-modal__container .profile-post-video-clip__data__positions-graph{
        width: 93%;
        background-color: var(--primary-very-dark-color);
        border-radius: 8px;
        margin: var(--space);
    }

    .post-profile_video_clip_post{
        width: 70%;
        margin: auto;
    }

    .profile-post-video-clip-media-modal_comments{
        width: 93%;
        margin: var(--space)
    }

    .profile-post-video-clip-modal__info-message__container {
        position: absolute;
        bottom: 0;
        margin: 0;
        padding: 6px;
    }
}`, "",{"version":3,"sources":["webpack://./src/app/profiles/components/profile-post-video-clips/ProfilePostVideoClipsComponent.styles.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,UAAU;IACV,8BAA8B;AAClC;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,8BAA8B;IAC9B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,+BAA+B;IAC/B,6BAA6B;AACjC;;AAEA;IACI,+BAA+B;IAC/B,gCAAgC;IAChC,kBAAkB;AACtB;;;AAGA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uCAAuC;IACvC,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,0BAA0B;IAC1B,eAAe;IACf,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,qCAAqC;IACrC,uCAAuC;IACvC,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,0BAA0B;IAC1B,eAAe;IACf,kBAAkB;IAClB,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,UAAU;IACV,uBAAuB;AAC3B;;AAEA;IACI,qCAAqC;IACrC,+BAA+B;AACnC;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,iDAAiD;IACjD,kBAAkB;IAClB,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI,8BAA8B;IAC9B,kBAAkB;IAClB,aAAa;IACb,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,kDAAkD;IAClD,aAAa;AACjB;;AAEA;IACI,0CAA0C;IAC1C,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,gCAAgC;IAChC,eAAe;AACnB;;;AAGA;IACI,eAAe;IACf,iBAAiB;AACrB;AACA;;;;;;;;;;GAUG;;;AAGH,yCAAyC,4BAA4B;IACjE;QACI,WAAW;QACX,YAAY;QACZ,SAAS;QACT,gBAAgB;QAChB,iDAAiD;QACjD,gBAAgB;IACpB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;QACb,sBAAsB;QACtB,YAAY;IAChB;;IAEA;QACI,UAAU;QACV,gDAAgD;QAChD,kBAAkB;QAClB,oBAAoB;IACxB;;IAEA;QACI,UAAU;QACV,YAAY;IAChB;;IAEA;QACI,UAAU;QACV;IACJ;;IAEA;QACI,kBAAkB;QAClB,SAAS;QACT,SAAS;QACT,YAAY;IAChB;AACJ","sourcesContent":[".profile-post-video-clip-modal__container{\n    display: flex;\n    align-items: flex-start;\n}\n\n.profile-post-video-clip-modal__container .profile-post-video-clip__data__positions-graph{\n    width: 55%;\n    background: var(--black-color);\n}\n\n.profile-post-video-clip__data__positions-graph .post-profile_video_clip_post{\n    aspect-ratio: unset;\n    text-align: center;\n    background: var(--black-color);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.profile-post-video-clip__data__positions-graph .post-profile_video_clip_post.lock {\n    opacity: 70%;\n    cursor: not-allowed;\n}\n\n.profile-post-video-clip__data__positions-graph .post-profile_video_clip_post .hubicon-lock_fill {\n    font-size: 24px;\n    position: absolute;\n}\n\n.profile-post-video-clip__data__positions-graph .post-profile_video_clip_post .hubicon-lock_fill::before {\n    color: var(--white-color);\n}\n\n.profile-post-video-clip__data__positions-graph .post-profile_video_clip_post .post-profile__video_clip{\n    max-width: 600px;\n    max-height: 700px;\n}\n\n.profile-post-video-clip__data__positions-graph .post-profile_video_clip_post .post-profile_video_clip_video-control{\n    height: 90%;\n}\n\n.profile-post-video-clip-media-modal_comments{\n    width: 45%;\n}\n\n.profile-post-video-clip-media-modal_comments .post_video_clips_actions__action{\n    margin-right: unset;\n}\n\n.profile_post_new-comment__photo{\n    margin-right: var(--space-half);\n    padding: var(--space-quarter);\n}\n\n.profile_post_new-comment__photo img{\n    width: var(--space-x2-and-half);\n    height: var(--space-x2-and-half);\n    border-radius: 50%;\n}\n\n\n.profile-post-video-clip-modal__tournament-match-info{\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n\n.profile-post-video-clip-modal__tournament_info{\n    display: flex;\n    align-items: center;\n    background: var(--new-background-color);\n    padding: 2px 4px;\n    border-radius: 2px;\n}\n\n.profile-post-video-clip-modal__tournament_info .baloa-table{\n    color: var(--primary-very-dark-color);\n}\n\n.profile-post-video-clip-modal__tournament_info__img{\n    margin-right: 4px;\n}\n\n.profile-post-video-clip-modal__tournament_info__img img {\n    width: 16px;\n    height: 16px;\n    border-radius: 50%;        \n}\n\n.profile-post-video-clip-modal__tournament_info__img .icon-ball {\n    color: var(--white-color );\n    font-size: 12px;\n    border-radius: 50%;\n    padding: 2px;    \n}\n\n.profile-post-video-clip-modal__match_date.baloa-table{\n    color: var(--primary-very-dark-color);\n    background: var(--new-background-color);\n    padding: 2px 4px;\n    border-radius: 2px;\n}\n\n.profile-post-video-clip-modal__tournament-match-data{\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-top: 14px;\n}\n\n.profile-post-video-clip-modal__tournament-match-data img{\n    width: 24px;\n    height: 24px;\n    border-radius: 50%;\n    margin: 0 8px;\n}\n\n.profile-post-video-clip-modal__tournament-match-data .icon-ball{\n    color: var(--white-color );\n    font-size: 20px;\n    border-radius: 50%;\n    padding: 2px;\n    margin: 0 8px;\n}\n\n.profile-post-video-clip-modal__tournament-match-data__score{\n    display: flex;\n    align-items: center;\n    width: 20%;\n    justify-content: center;\n}\n\n.profile-post-video-clip-modal__tournament-match-data__label.baloa-table{\n    color: var(--primary-very-dark-color);\n    font-weight: var(--font-medium);\n}\n\n.profile-post-video-clip-modal__tournament-match-data__score__left {\n    text-align: end;\n}\n\n.profile-post-video-clip-modal__tournament-match-data__score__right {\n    text-align: start;\n}\n\n.profile-post-video-clip-modal__tournament-match-data__score__center{\n    margin: 0 4px;\n}\n\n.profile-post-video-clip-modal__table-body__container{\n    box-shadow: 0px 1px 4px rgba(150, 150, 150, 0.25);\n    border-radius: 8px; \n    padding: 12px 8px;\n    margin: 24px;\n}\n\n.profile-post-video-clip-modal__info-message__container {\n    background: var(--white-color);\n    border-radius: 8px;\n    padding: 12px;\n    margin: 12px;\n}\n\n.profile-post-video-clip-modal__info-message {\n    display: flex;\n    align-items: center;\n    border-radius: 4px;\n    background: var(--new-informative-banner-bg-color);\n    padding: 12px;\n}\n\n.profile-post-video-clip-modal__info-message .hubicon-info::before {\n    color: var(--new-informative-banner-color);\n    margin-right: 8px;\n}\n\n.profile-post-video-clip-modal__info-message__text .baloa-normal-medium {\n    display: flex;\n    align-items: center;\n}\n\n.profile-post-video-clip-modal__info-message__text .baloa-names{\n    font-weight: var(--font-regular);\n    margin-top: 8px;\n}\n\n\n.profile-post-video-clip-modal__info-message__text .hubicon-award_star {\n    font-size: 20px;\n    margin-right: 4px;\n}\n/* @media screen and (max-width: 1600px){\n    .profile-post-video-clip-modal .modal2__container{\n        width: 90%;\n    }\n}\n\n@media screen and (max-width: 1100px){\n    .profile-post-video-clip-modal .modal2__container{\n        width: 90%;\n    }\n} */\n\n\n@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */\n    .profile-post-video-clip-modal .modal2__container{\n        width: 100%;\n        height: 100%;\n        margin: 0;\n        border-radius: 0;\n        box-shadow: 0px 1px 4px rgba(150, 150, 150, 0.25);\n        max-height: 100%;\n    }\n\n    .profile-post-video-clip-modal .modal2__content{\n        height: 100vh;\n    }\n\n    .profile-post-video-clip-modal__container{\n        display: flex;\n        flex-direction: column;\n        height: 100%;\n    }\n\n    .profile-post-video-clip-modal__container .profile-post-video-clip__data__positions-graph{\n        width: 93%;\n        background-color: var(--primary-very-dark-color);\n        border-radius: 8px;\n        margin: var(--space);\n    }\n\n    .post-profile_video_clip_post{\n        width: 70%;\n        margin: auto;\n    }\n\n    .profile-post-video-clip-media-modal_comments{\n        width: 93%;\n        margin: var(--space)\n    }\n\n    .profile-post-video-clip-modal__info-message__container {\n        position: absolute;\n        bottom: 0;\n        margin: 0;\n        padding: 6px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
